import React, { memo } from 'react';

import './RadioCircle.css';

type RadioCircleProps = {
  isSelected?: boolean;
};

export const RadioCircle: React.FC<RadioCircleProps> = memo(
  ({ isSelected }) => {
    return (
      <div
        className={`radio-circle--option-button ${
          isSelected ? 'radio-circle--option-button-selected' : ''
        }`}
      >
        {isSelected && (
          <div className="radio-circle--option-button-selected-circle" />
        )}
      </div>
    );
  }
);
